import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";

require('./visit-plan-routes-panel-context-menu.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-routes-panel-context-menu',
  templateUrl: './visit-plan-routes-panel-context-menu.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanRoutesPanelContextMenuComponent implements OnInit {

  @Input() isRouteDispatched: boolean;
  @Input() hasNotSyncedChanges: boolean;
  @Output() onClose = new EventEmitter();
  @Output() onActionSelected = new EventEmitter<string>();


  constructor(@Inject(PANEL_DATA) public data: { isRouteDispatched: boolean, hasNotSyncedChanges?: boolean }) {
  }

  ngOnInit() {
    this.isRouteDispatched = this.data.isRouteDispatched;
    this.hasNotSyncedChanges = this.data.hasNotSyncedChanges;
  }

  get blockedActionTooltipKey(): string {
    return this.isRouteDispatched ? 'VISIT_SCHEDULE_TOOLTIPS.ACTION_BLOCKED_CALL_DISPATCHED' : '';
  }

  emitAction(action: string) {
    if(this.isRouteDispatched || this.hasNotSyncedChanges) return;
    this.onActionSelected.emit(action);
    this.close();
  }

  close() {
    this.onClose.emit();
  }
}
